// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__d7IRd","name":"ConsentHeader_name__37ckQ","birthday":"ConsentHeader_birthday__31XJD","skeleton":"ConsentHeader_skeleton__20aCJ"};